import React, { useState } from 'react'
import {useDispatch,useSelector} from 'react-redux'
import styled from 'styled-components'
import { colors } from '../../../styles/colors';
import { PrimaryButton } from '../../UI/PrimaryButton';
import { LinkButton } from '../../UI/LinkButton';
import { getCalculatedSum } from '../../../functions/getCalculatedSum';
import { ChangeButton } from '../../UI/ChangeButton';
import { Cross } from '../../UI/Cross';
import { useFirebase } from 'react-redux-firebase';

const Container = styled.div`
    width: 260px;
    height: 310px;

    position: relative;
    overflow: hidden;

    margin: 0 40px 180px 40px;
     
    padding: 3rem 2.5rem 3.75rem 2.5rem;
    border: 1px solid ${colors.dark_blue};

    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: 960px) {

        :hover {
            width: 340px;
            // height: 460px;
            height: auto;
            
            margin: 0;
            margin-bottom: 24px;

            padding: 2rem 2.5rem 2.5rem 2.5rem;
            box-shadow: 0px 0px 20px #00253D;
    
            .block-to-hide {
                overflow: hidden;
                height: auto;
            }

            .change-button,
            .cross-button {
                width: 23rem;
                height: 23rem;        
            }        
        }
    }
    @media (min-width: 321px) and (max-width: 959.98px) {
        width: 340px;
        height: auto;

        margin: 2rem;
        margin-bottom: 12.5rem;
    }
    @media (max-width: 767.98px) {
        margin: 0;
        margin-bottom: 6.25rem;

        width: 100%;
        max-width: 340px;
        height: auto;
    }

    // INCLUDED CLASSES:

    .change-button,
    .cross-button {
        width: 0;
        height: 0;

        transition: all .25s;
        overflow: hidden;

        top: -10rem;
        padding: 6rem;

        display: flex;
        align-items: flex-end;

        background: white;
        border-radius: 50%;

        @media (max-width: 959.98px) {
            width: 23rem;
            height: 23rem;        
        }

    }
    .change-button {
        position: absolute;
        left: -10rem;
        justify-content: flex-end;

        svg {
            width: 4rem;
            height: 4rem;
        }

    }
    .cross-button {
        right: -10rem;

        svg {
            width: 3.5rem;
            height: 3.5rem;
        }
    }

    .product-card_pic {
        width: 100%;
        height: 100px;

        background: #fff url(${props => props.product_picture}) no-repeat 50% 50%;
        background-size: contain;

        margin-bottom: 2.5rem;
    }
    .product-card_name {

        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        text-transform: uppercase;
        text-align: center;
        margin: .5em 0;
    }
    .product-card_price {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;
    }

    .block-to-hide {
        overflow: hidden;
        height: 0;
        transition: all .5s;
        
        display: flex;
        flex-direction: column;
        align-items: center;

        @media (max-width: 959.98px) {
            height: auto;
        }

    }

    .link-button {
        margin: 1rem 0;
    }

    .add-to-cart-block {
        display: flex;
        flex-direction: column;

        align-items: center;
        justify-content: space-between;
    }

    .add-to-cart-block_product-count {
        display: flex;
        justify-content: space-between;
        margin: 2rem 0;
    }

    .counter {
        width: 10rem;
        background: none;
        border: none;
        outline: none;

        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        text-align: center;

        ::-webkit-inner-spin-button,
        ::-webkit-outer-spin-button {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            margin: 0;
        }

        :hover {
            color: ${colors.red};
            cursor: pointer;
        }
    }

    .counter-btn {
        background: ${colors.dark_blue};
        color: ${colors.white};
        cursor: pointer;
        padding: 2rem;

    } 
`;

export const ProductCard = ({ product_data }) => {
    const dispatch = useDispatch()
    const firebase = useFirebase()

    const loggedIn = useSelector(state => state.firebase.auth.isEmpty === false)
    const product_in_db = firebase.ref('products/products_list').child(`${product_data.key}`)

    const id = product_data.key
    const product_name= product_data.product_name
    const product_picture = product_data.pictures ? product_data.pictures[0].url : null ;    
    const price = product_data.price

    const [count, setCount] = useState(1)

    function handleCounter (value) {
        switch (value) {
            case '-':
                if (count > 1 ) {
                    setCount( count - 1 )
                }
                break
            case '+':
                setCount( count + 1 )
                break
            default:
                if ( value < 1 ) {
                    setCount( 1 )
                } else {
                    setCount(value)
                }
        }
    }

    const handleAddToCart = () => {
        dispatch({ type: 'ADD_TO_CART', value: {product_name, count, id, price, product_picture } })
        alert('Товар добавлен в корзину')
        setCount(1)
    }

    function showProductPage () {
        dispatch({ type: 'PRODUCT_PAGE_SET_PRODUCT', product_data })
        dispatch({ type: 'PRODUCT_PAGE_OPENED'})
    }

    function handleDeleteProduct () {
        const del_confirm = window.confirm('Вы действительно хотите удалить этот товар?')
        if (del_confirm) {
            product_in_db.remove()
        }
    }
    function handleChangeProduct () {
        dispatch({ type: 'CHANGE_PRODUCT_OPENED', data: product_data })
    }
    
    return (
        <Container product_picture={ product_picture } className='product-card'>
            { loggedIn 
                ? <>
                    <div onClick={ handleChangeProduct }><ChangeButton /></div>
                    <div onClick={ handleDeleteProduct }><Cross /></div>
                </>
                : null 
            }
            
            <div className="product-card_pic" />
            <p className='product-card_name' >{product_name}</p>
            <span className='product-card_price' > { getCalculatedSum(price, count) } </span>

            <div className="block-to-hide">

                <div onClick={ ()=> showProductPage() }>
                    <LinkButton link='#' text='Подробнее' />
                </div>

                <div className="add-to-cart-block">
                    <div className="add-to-cart-block_product-count">
                        <span onClick={()=> handleCounter('-')}  className='counter-btn' >-</span>
                        <input className='counter' type="number" onChange={ e => handleCounter( +e.target.value ) }  value={count} />
                        <span onClick={()=> handleCounter('+')} className='counter-btn' >+</span>
                    </div>
                    <PrimaryButton  onClick={ ()=> handleAddToCart() } >Добавить в корзину</PrimaryButton>
                </div>
                
            </div>

        </Container>
    )
}

